import styled from "styled-components";

export const MinimumGamblingAgeIconDefaultBox = styled.img<{isShownInHeader: boolean, isWide?: boolean}>`
  height: ${props=> props.isWide === true ? "33px" : "27px"};
  width: ${props => props.isWide === true ? "96px" : (props.isShownInHeader === true ? "35px" : "27px")};
  min-width: ${props => props.isWide === true ? "96px" : "initial"};
`